export default index => ({
    _id: new Array(index + 1)
        .fill(null)
        .reduce(
            (res, f, i) => ({ ...res, [`value_${i}`]: i === index ? `$value_map_${i}` : `$value_${i}` }),
            {}
        ),
})
